﻿const host = window.location.protocol + '//' + window.location.host;
const systemRoutes = {
  Common: {
    Id: 1,
    Name: 'Gerencial',
    Url: host,
  },
  SistemaAtendimento: {
    Id: 4,
    Name: 'Sistema de Atendimento',
    Url: host + '/sa/#/',
  },
  SistemaContabilidade: {
    Id: 11,
    Name: 'Contabilidade',
    Url: host + '/cp/#/',
  },
  SistemaRecursosHumanos: {
    Id: 12,
    Name: 'Recursos Humanos',
    Url: host + '/rh/#/',
  },
  SistemaMaterial: {
    Id: 13,
    Name: 'Sistema de Gestão de Materiais',
    Url: host + '/ma/#/',
  },
  SistemaAguaEsgoto: {
    Id: 14,
    Name: 'Sistema de Água e Esgoto',
    Url: host + '/ag/#/',
  },
  SistemaAdministracaoMaterial: {
    Id: 15,
    Name: 'Sistema de Administração Materiais',
    Url: host + '/am/#/',
  },
  SistemaBackOffice: {
    Id: 2,
    Name: 'BackOffice',
    Url: host + '/bo/#/',
  },
  SistemaTributario: {
    Id: 16,
    Name: 'Sistema de Tributação',
    Url: host + '/tb/#/',
  },
  SistemaCemiterio: {
    Id: 17,
    Name: 'Sistema de Cemitério',
    Url: host + '/it/#/',
  },
  SistemaGestaoMateriais: {
    Id: 18,
    Name: 'Sistema de Gestão de Materiais',
    Url: host + '/gm/#/',
  },
  SistemaPowerBI: {
    Id: 19,
    Name: 'Business Intelligence',
    Url: host + '/bi/#/',
  },
  SistemaESocial: {
    Id: 20,
    Name: 'eSocial',
    Url: host + '/esocial/#/',
  },
  SistemaGestaoTributos: {
    Id: 21,
    Name: 'Sistema Tributário',
    Url: host + '/tributario/#',
  },
  SistemaFrotas: {
    Id: 28,
    Name: 'Sistema Frotas',
    Url: host + '/frotas/#/',
  },
  SistemaSaudeSeguranca: {
    Id: 29,
    Name: 'Saúde e Segurança do Trabalho',
    Url: host + '/ss/#/',
  },
  SistemaRelatorios: {
    Id: 30,
    Name: 'Relatórios Personalizados',
    Url: host + '/rep/#',
  },
  SistemaRestaurante: {
    Id: 32,
    Name: 'Sistema Gerenciador de Restaurante',
    Url: host + '/gr/#/',
  },
  SistemaTreinamento: {
    Id: 33,
    Name: 'Sistema Gerenciador de Treinamento',
    Url: host + '/tr/#/',
  },
};

export default systemRoutes;
